// Texty pásu dopravy zadarmo — slovenské dvojča locale/cs/benefitBand.js.
export default {
  leftA: 'Objednajte ešte za ',
  leftB: (scope) => ' a dopravu ' + scope + ' máte zadarmo.',
  reached: (scope) => 'Dopravu ' + scope + ' máte zadarmo.',
  barLabel: 'Postup k doprave zadarmo',
};
